import { Product, Concept } from './types';
const productsConceptsData = require('./products_concepts_link.json');

const globalConcepts = productsConceptsData.concepts || [];

const conceptsMap = new Map<string, any>();

if (Array.isArray(globalConcepts)) {
  globalConcepts.forEach((concept: any) => {
    if (concept && concept.id) {
      conceptsMap.set(concept.id, concept);
    }
  });
}

export const products: Product[] = productsConceptsData.products.map((product: any) => {
  const sortedConceptIds: string[] = product['sorted-concepts'] || [];

  const productConcepts: Concept[] = sortedConceptIds.map((conceptId: string, index: number) => {
    const conceptData = conceptsMap.get(conceptId);

    if (conceptData) {
      return {
        id: conceptId,
        imageUrl: conceptData.imageUrl || `https://picsum.photos/seed/${conceptId}/300/300`,
        name: conceptData.name || `Concept ${conceptId.substring(0, 8)}`,
        sortOrder: index
      };
    } else {
      return {
        id: conceptId,
        imageUrl: `https://picsum.photos/seed/${conceptId}/300/300`,
        name: `Concept ${conceptId.substring(0, 8)}`,
        sortOrder: index
      };
    }
  });

  const defaultOrderIds: string[] = [];
  globalConcepts.forEach((concept: any) => {
    if (sortedConceptIds.includes(concept.id)) {
      defaultOrderIds.push(concept.id);
    }
  });

  sortedConceptIds.forEach((id: string) => {
    if (!defaultOrderIds.includes(id)) {
      defaultOrderIds.push(id);
    }
  });

  const alexOrder = sortedConceptIds;

  return {
    id: product.id,
    name: product.name,
    imageUrl: product.imageUrl || `https://picsum.photos/seed/${product.id}/300/300`,
    description: `Product description for ${product.name}`,
    category: 'Clothing',
    concepts: productConcepts,
    defaultOrder: defaultOrderIds,
    alexOrder: alexOrder
  };
});